import React, { Component } from 'react';
import Core from './../../Core/Core';
import ReworkItem from './ReworkItem';
import ErrorManager from '../../Core/ErrorManager';

class ReworkItems extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            "start" : 0,
            "length" : 40,
            "page" : 1,
            "conflicts" : []
        }

        this.load();

        this.node = React.createRef();
        this.load = this.load.bind(this);

        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);

        this.retrieveData = this.retrieveData.bind(this);
        this.handleItem = this.handleItem.bind(this);
    }

    load()
    {
        this.props.onChange([]);
        Core.Instance.Request(Core.Address+"Conflict?offset="+this.state.start+"&limit="+this.state.length, null, "GET")
        .then((json) => {
            let conflicts = Array.isArray(json) ? json : [];
            return Promise.all(conflicts.map((c) => {
                return this.retrieveData(c);
            }));
        })
        .then((conflicts) => {
            this.setState({
                "conflicts" : conflicts
            })
        })
    }

    retrieveData(conflict)
    {
        return new Promise((resolve, reject) => {
            Core.Instance.Request(Core.Address+conflict.Table_name+"/"+conflict.Table_id, null, "GET")
            .then((json) => {
                conflict.entry = json;
                return Promise.all(
                    conflict.clients.split(";").map((e) => {
                        return Core.Instance.Request(Core.Address+"Client/"+e, null, "GET");
                    })
                );
            })
            .then((data) => {
                conflict.clientslist = data != null ? data : [];
                resolve(conflict);
            })
            .catch((error) => {
                reject(error);
            })
        });
    }

    checkModification()
    {
        for(let i = 0; i < this.state.conflicts.length; i++)
        {
            if(this.state.conflicts[i].client !=  null && this.state.conflicts[i].client != "")
            {
                return !window.confirm("Vous avez des modifications non sauvegardées sur cette page, êtes-vous sûrs de vouloir les abandonner ?");
            }
        }
        return false;
    }

    next()
    {
        if(this.checkModification())
            return;
        this.setState({
            "start" : this.state.start + this.state.length,
            "page" : this.state.page + 1,
        }, this.load);
    }

    prev()
    {
        if(this.checkModification())
            return;
        this.setState({
            "start" : this.state.start - this.state.length,
            "page" : this.state.page - 1,
        }, this.load);
    }

    handleItem(evt)
    {
        let conflicts = this.state.conflicts;
        conflicts[evt.target.name].client = evt.target.value;
        this.props.onChange(conflicts);
        this.setState({
            "conflicts" : conflicts
        });
    }


    render()
    {
        let index = -1;
        let items = this.state.conflicts.map((e) => {
            if(e == null)
                return null;
            index++;
            return <ReworkItem conflict={ e } index={ index } onChange={ this.handleItem }  />
        })
            
        return (
            <div ref={ this.node } className="card m-3 p-3">
                { 
                    this.state.conflicts.length > 0 &&
                    <nav aria-label="Page navigation example" className="mx-auto text-center" style={{ "width" : "190px" }}>
                        <ul className="pagination text-center mx-auto">
                            <li className={"page-item "+(this.state.start <= 0 ? "disabled" : "") }><a className="page-link" href="#" onClick={ this.prev }>Précédent</a></li>
                            <li className="page-item"><a className="page-link" >{this.state.page}</a></li>
                            <li className={"page-item"}><a onClick={ this.next } className="page-link" href="#">Suivant</a></li>
                        </ul>
                    </nav>
                }
                    { items }
                { 
                    this.state.conflicts.length > 0 &&
                    <nav aria-label="Page navigation example" className="mx-auto text-center" style={{ "width" : "190px" }}>
                        <ul className="pagination text-center mx-auto">
                            <li className={"page-item "+(this.state.start <= 0 ? "disabled" : "") }><a className="page-link" href="#" onClick={ this.prev }>Précédent</a></li>
                            <li className="page-item"><a className="page-link" >{this.state.page}</a></li>
                            <li className={"page-item"}><a onClick={ this.next } className="page-link" href="#">Suivant</a></li>
                        </ul>
                    </nav>
                }

                { 
                    this.state.conflicts.length === 0 &&
                    <span className="card-body text-center h5 p-0" role="alert">
                        Aucun conflit
                    </span>
                }
            </div>
        );
    }
}

export default ReworkItems;


// WEBPACK FOOTER //
// ./src/Components/Rework/ReworkItems.js